import React from 'react';
import { styled } from '@compiled/react';
import Avatar from '@atlaskit/avatar';
import { type OptionProps, type OptionType, CheckboxOption } from '@atlaskit/select';
import { token } from '@atlaskit/tokens';

type FilterUserCheckboxProps = {} & OptionProps<OptionType, true>;

export const FilterUserCheckbox = ({ ...props }: FilterUserCheckboxProps) => {
	const { data, children } = props;
	return (
		<CheckboxOption {...props}>
			<AuthorCheckbox>
				<Avatar size="small" src={data.picture} />
				{children}
			</AuthorCheckbox>
		</CheckboxOption>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const AuthorCheckbox = styled.div({
	display: 'flex',
	alignItems: 'center',
	gap: token('space.050', '4px'),
});
